// extracted by mini-css-extract-plugin
export var link = "_s4-0";